<template>
<div class="chapter">
<div class="inner_page">
<p class="center3"><a id="page_v"></a>JON:</p>
<p class="center">To my parents, whose bookshelves, patience, and support</p>
<p class="center">(as well as willingness to take trips to battlefields and historic sites!)</p>
<p class="center">guided me to this point and continue to help me.</p>
<p class="center2">CHRIS:</p>
<p class="center">To Sarah Kay Bierle, ECW’s managing editor—</p>
<p class="center">this book series is a monument to her years of hard work and daily oversight of Emerging Civil War’s blog.</p>
<p class="center">None of this would be possible without her.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Epigraph.vue?3505c3b2